import React from 'react';

import { IIconProps, TIconType } from '../interface';

const OwnerIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			data-id='icon'
			data-testid='owner'
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
			{...props?.innerSvgProps}
		>
			<path
				d='M1.5 20.25H15'
				data-id='icon'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M13.5 7.5V3.75C13.5 3.55109 13.421 3.36032 13.2803 3.21967C13.1397 3.07902 12.9489 3 12.75 3H3.75C3.55109 3 3.36032 3.07902 3.21967 3.21967C3.07902 3.36032 3 3.55109 3 3.75V20.25'
				data-id='icon'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M6 6.75H9'
				data-id='icon'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M7.5 12.75H10.5'
				data-id='icon'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M6 16.5H9'
				data-id='icon'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M16.4 15.5C18.4711 15.5 20.15 13.8211 20.15 11.75C20.15 9.67893 18.4711 8 16.4 8C14.3289 8 12.65 9.67893 12.65 11.75C12.65 13.8211 14.3289 15.5 16.4 15.5Z'
				data-id='icon'
				fill='currentColor'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M11 18.875C11.4939 17.8635 12.262 17.0111 13.2167 16.4148C14.1714 15.8186 15.2744 15.5024 16.4 15.5024C17.5256 15.5024 18.6286 15.8186 19.5833 16.4148C20.538 17.0111 21.3061 17.8635 21.8 18.875'
				data-id='icon'
				fill='currentColor'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default OwnerIcon;
